function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDoubleLeft = function SvgChevronDoubleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.634 1.743a.75.75 0 01.106 1.055l-4.255 5.2 4.255 5.2a.75.75 0 01-1.161.95L1.935 8.473a.75.75 0 010-.95L6.58 1.848a.75.75 0 011.055-.105zm5.484 0a.75.75 0 01.106 1.055l-4.255 5.2 4.255 5.2a.75.75 0 01-1.161.95L7.42 8.473a.75.75 0 010-.95l4.643-5.675a.75.75 0 011.055-.105z",
    fill: props.fill
  }));
};
export default SvgChevronDoubleLeft;